export interface RedirectLocation {
	href: string;
	pathname: string;
	search: string;
}

export interface RedirectInfo {
	status: number;
	location: RedirectLocation;
}

export interface ISeoMetadata {
	[key: string]: unknown;
}

export interface RouteInfo {
	url: string;
	action: string;
	locale: string;
	queryString: string;
	alternativeUrl?: string;
	queryParams: {
		[propName: string]: any;
	};
	metadata: ISeoMetadata;
	pageUrls: {
		[key: string]: string;
	};
	jsonld: any[];
	prevAlternativeCgid: string;
	expirationTime: number;
	redirectsStack?: [RedirectInfo];
	_isHomePage?: boolean;
	_contentfulPageData?: {
		data: any;
		localizedSlug: Record<string, string> | undefined;
		localizedSeo: Record<string, unknown> | undefined;
		slug: string;
	};
	_categoryPageCmsData?: Record<string, unknown> | null;
}

export interface SFCCAPIConfig {
	siteId: string;
	pathPrefix: string;
	proxyPath: string;
	cachedProxyPath: string;
	cachedProxyHost: string;
}

export interface CSRFToken {
	token: string;
	tokenName: string;
}

export enum LogType {
	SERVER = 'server',
	CLIENT = 'client',
}

export enum LogLevel {
	ERROR = 'error',
	WARNING = 'warning',
	DEBUG = 'debug',
	INFO = 'info',
}

export interface Store {
	ID: string;
	address1: string;
	address2: string;
	bookAppointmentDetails?: string;
	bookAppointmentHours?: BookAppointmentHour[];
	bookAppointmentTitle?: string;
	city: string;
	countryCode: string;
	email: string;
	gallery?: string[];
	isBookAnAppointmentAvailable?: boolean;
	isEnabledMoreDetailsLink?: boolean;
	kiboStoreId?: string;
	latitude: number;
	longitude: number;
	mobileGallery?: string[];
	name: string;
	phone?: string;
	postalCode: string;
	services: any;
	storeDescription?: string;
	storeFilter: string;
	storeHours: string;
	storeType: string;
	whatsapp: string;
}

export interface StoreHour {
	start: string;
	end: string;
}

export interface BookAppointmentHour {
	day: number;
	hours: StoreHour[];
}

export interface StoreWithBookAppointment extends Store {
	bookAppointmentsHours: BookAppointmentHour[];
}

export interface CreateReservationRequest {
	firstName: string; // max length 30
	lastName: string; // max length 30
	email: string;
	salutation: string; // max length 5
	products: string[];
	phoneCode: string; // max length 5
	phone: string; // max length 50
	message: string; // max length 200
}

export interface FindAvailableStoresRequest {
	productId: string;
}
export interface FindAvailableStoresResponse {
	action: string;
	error: boolean;
	errorMessage: string;
	locale: string;
	queryString: string;
	stores: StoreWithBookAppointment[];
	validation: {
		valid: boolean;
		fields: Record<string, any>;
	};
}

export const NOT_FOUND_ACTION = 'Home-ErrorNotFound';
